import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useTranslation } from '@/common/i18n';

/* TODO: make this accessible */
/* TODO: Use icon from theme */
type PopoverTipProps = {
  content: string;
};
const PopoverTip = (props: PopoverTipProps) => {
  const {
    content
  } = props;
  const {
    t
  } = useTranslation();
  return <Tooltip title={content} placement="top" arrow aria-label={t('definition')} data-sentry-element="Tooltip" data-sentry-component="PopoverTip" data-sentry-source-file="PopoverTip.tsx">
      <IconButton size="small" sx={{
      height: '14px',
      width: '14px',
      p: 0,
      m: 0.25
    }} data-sentry-element="IconButton" data-sentry-source-file="PopoverTip.tsx">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16" data-sentry-element="svg" data-sentry-source-file="PopoverTip.tsx">
          <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" data-sentry-element="path" data-sentry-source-file="PopoverTip.tsx" />
        </svg>
      </IconButton>
    </Tooltip>;
};
export default PopoverTip;